(function() {
  'use strict';

  const STORAGE_KEY = 'goszemlya_web_token';
  const USER_KEY = 'goszemlya_web_user';

  let currentUser = null;
  let currentEmail = '';
  let isSending = false;

  // ── DOM refs ────────────────────────────────────────────────────
  const modal = document.getElementById('auth-modal');
  const backdrop = document.getElementById('auth-modal-backdrop');
  const closeBtn = document.getElementById('auth-modal-close');
  const stepEmail = document.getElementById('auth-step-email');
  const stepCode = document.getElementById('auth-step-code');
  const emailInput = document.getElementById('auth-email-input');
  const emailError = document.getElementById('auth-email-error');
  const sendCodeBtn = document.getElementById('auth-send-code-btn');
  const codeEmailSpan = document.getElementById('auth-code-email');
  const codeInputs = [
    document.getElementById('auth-code-1'),
    document.getElementById('auth-code-2')
  ];
  const codeError = document.getElementById('auth-code-error');
  const verifyBtn = document.getElementById('auth-verify-btn');
  const backToEmailBtn = document.getElementById('auth-back-to-email');
  const profilePanelBody = document.getElementById('profile-panel-body');
  const profileLoginBtn = document.getElementById('profile-login-btn');

  // ── Helpers ─────────────────────────────────────────────────────
  function esc(str) {
    if (str == null) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim().toLowerCase());
  }

  // Cookie helpers — fallback when localStorage is cleared/unavailable
  function setCookie(name, value, days) {
    try {
      const maxAge = days * 24 * 60 * 60;
      document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    } catch (e) {}
  }
  function getCookie(name) {
    try {
      const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) { return null; }
  }
  function removeCookie(name) {
    try { document.cookie = name + '=; path=/; max-age=0'; } catch (e) {}
  }

  function getToken() {
    try {
      const fromStorage = localStorage.getItem(STORAGE_KEY);
      if (fromStorage) return fromStorage;
    } catch (e) {}
    return getCookie(STORAGE_KEY);
  }

  function setToken(token) {
    try { localStorage.setItem(STORAGE_KEY, token); } catch (e) {}
    setCookie(STORAGE_KEY, token, 30);
  }

  function removeToken() {
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(USER_KEY);
    } catch (e) {}
    removeCookie(STORAGE_KEY);
    removeCookie(USER_KEY);
  }

  function setCurrentUser(user) {
    currentUser = user;
    const raw = JSON.stringify(user);
    try { localStorage.setItem(USER_KEY, raw); } catch (e) {}
    setCookie(USER_KEY, raw, 30);
    updateProfilePanel();
  }

  function getStoredUser() {
    try {
      const raw = localStorage.getItem(USER_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    try {
      const raw = getCookie(USER_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return null;
  }

  function showModal() {
    if (!modal) return;
    modal.style.display = 'flex';
    resetEmailStep();
    setTimeout(() => { if (emailInput) emailInput.focus(); }, 50);
  }

  function hideModal() {
    if (!modal) return;
    modal.style.display = 'none';
  }

  function resetEmailStep() {
    stepEmail.style.display = 'block';
    stepCode.style.display = 'none';
    if (emailInput) {
      emailInput.value = '';
      emailInput.classList.remove('auth-input-error');
    }
    emailError.classList.remove('visible');
    sendCodeBtn.disabled = true;
    currentEmail = '';
    codeInputs.forEach(input => { input.value = ''; });
    codeError.classList.remove('visible');
    verifyBtn.disabled = true;
  }

  function showCodeStep(email) {
    stepEmail.style.display = 'none';
    stepCode.style.display = 'block';
    currentEmail = email;
    if (codeEmailSpan) codeEmailSpan.textContent = email;
    setTimeout(() => { if (codeInputs[0]) codeInputs[0].focus(); }, 50);
  }

  function updateSendButton() {
    if (!sendCodeBtn || !emailInput) return;
    sendCodeBtn.disabled = !isValidEmail(emailInput.value) || isSending;
  }

  function showEmailError(show) {
    if (!emailError || !emailInput) return;
    emailError.classList.toggle('visible', show);
    emailInput.classList.toggle('auth-input-error', show);
  }

  function showCodeError(show) {
    if (!codeError) return;
    codeError.classList.toggle('visible', show);
  }

  function getCodeValue() {
    return codeInputs.map(i => i.value.replace(/\D/g, '')).join('');
  }

  function updateVerifyButton() {
    if (!verifyBtn) return;
    verifyBtn.disabled = getCodeValue().length !== 6;
  }

  // ── API ─────────────────────────────────────────────────────────
  async function apiPost(path, body) {
    const res = await fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    return { ok: res.ok, status: res.status, data };
  }

  async function apiGet(path) {
    const headers = {};
    const token = getToken();
    if (token) headers['Authorization'] = 'Bearer ' + token;
    const res = await fetch(path, { headers });
    const data = await res.json().catch(() => ({}));
    return { ok: res.ok, status: res.status, data };
  }

  async function sendCode() {
    const email = emailInput.value.trim().toLowerCase();
    if (!isValidEmail(email)) {
      showEmailError(true);
      sendCodeBtn.disabled = true;
      return;
    }

    isSending = true;
    sendCodeBtn.disabled = true;
    sendCodeBtn.textContent = 'Отправка...';
    showEmailError(false);

    const result = await apiPost('/api/auth/send-code', { email });

    isSending = false;
    sendCodeBtn.textContent = 'Получить код';

    if (result.ok) {
      showCodeStep(email);
    } else {
      showEmailError(true);
      sendCodeBtn.disabled = false;
      if (result.data && result.data.retry_after) {
        emailError.textContent = 'Подождите ' + result.data.retry_after + ' сек.';
      } else {
        emailError.textContent = result.data.error || 'Неверно указан email';
      }
    }
  }

  async function verifyCode() {
    const code = getCodeValue();
    if (code.length !== 6) return;

    verifyBtn.disabled = true;
    verifyBtn.textContent = 'Проверка...';
    showCodeError(false);

    const result = await apiPost('/api/auth/verify-code', { email: currentEmail, code });

    verifyBtn.textContent = 'Войти';

    if (result.ok && result.data.token) {
      setToken(result.data.token);
      setCurrentUser(result.data.user);
      hideModal();
      // Refresh profile panel if open
      updateProfilePanel();
      window.dispatchEvent(new CustomEvent('auth:change', { detail: { authenticated: true } }));
    } else {
      showCodeError(true);
      codeError.textContent = result.data.error || 'Код подтверждения указан не верно';
      verifyBtn.disabled = false;
    }
  }

  async function loadCurrentUser() {
    const token = getToken();
    if (!token) {
      currentUser = null;
      updateProfilePanel();
      return;
    }
    const result = await apiGet('/api/auth/me');
    if (result.ok && result.data.user) {
      setCurrentUser(result.data.user);
      window.dispatchEvent(new CustomEvent('auth:change', { detail: { authenticated: true } }));
      return;
    }
    if (result.status === 401) {
      // Token is invalid/expired — clear everything
      removeToken();
      currentUser = null;
      updateProfilePanel();
      window.dispatchEvent(new CustomEvent('auth:change', { detail: { authenticated: false } }));
      return;
    }
    // Network or server error: keep stored user/token and restore UI from storage
    currentUser = getStoredUser();
    updateProfilePanel();
  }

  // ── Profile panel ───────────────────────────────────────────────
  function updateProfilePanel() {
    if (!profilePanelBody) return;
    if (currentUser) {
      profilePanelBody.innerHTML = `
        <div style="width: 100px; height: 100px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; color: white; font-size: 40px;">👤</div>
        <div style="font-size: 18px; font-weight: 600; color: #1a1a2e; margin-bottom: 6px;">${esc(currentUser.email)}</div>
        <div style="font-size: 14px; color: #888; margin-bottom: 24px;">Авторизован</div>
        <button id="profile-logout-btn" class="lot-premium-link" style="width: 100%; justify-content: center; background: #e0e0e0; color: #333; border: none;">
          Выйти
        </button>
      `;
      const logoutBtn = document.getElementById('profile-logout-btn');
      if (logoutBtn) logoutBtn.addEventListener('click', logout);
    } else {
      profilePanelBody.innerHTML = `
        <div style="width: 100px; height: 100px; background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; color: white; font-size: 40px;">👤</div>
        <div style="font-size: 18px; font-weight: 600; color: #1a1a2e; margin-bottom: 6px;">Гость</div>
        <div style="font-size: 14px; color: #888; margin-bottom: 24px;">Не авторизован</div>
        <button id="profile-login-btn" class="lot-premium-link" style="width: 100%; justify-content: center; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border: none;">
          Войти
        </button>
      `;
      const loginBtn = document.getElementById('profile-login-btn');
      if (loginBtn) loginBtn.addEventListener('click', showModal);
    }
  }

  function logout() {
    removeToken();
    currentUser = null;
    updateProfilePanel();
    window.dispatchEvent(new CustomEvent('auth:change', { detail: { authenticated: false } }));
  }

  function isAuthenticated() {
    if (currentUser) return true;
    if (getStoredUser()) return true;
    if (typeof window.tgIsAuthed === 'function' && window.tgIsAuthed()) return true;
    return false;
  }

  function showLogin() {
    if (modal) {
      showModal();
      return;
    }
    if (typeof window.tgShowAuthOverlay === 'function') {
      window.tgShowAuthOverlay();
    }
  }

  function requireAuth() {
    if (isAuthenticated()) return true;
    showLogin();
    return false;
  }

  // ── Event handlers ──────────────────────────────────────────────
  function init() {
    // Check URL hash for token from email link
    const hash = window.location.hash;
    if (hash && hash.includes('auth_token=')) {
      const params = new URLSearchParams(hash.slice(1));
      const token = params.get('auth_token');
      if (token) {
        setToken(token);
        window.location.hash = '';
      }
    }

    currentUser = getStoredUser();
    updateProfilePanel();
    loadCurrentUser();

    // Profile panel login button (initial)
    if (profileLoginBtn) {
      profileLoginBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        showModal();
      });
    }

    // Modal close
    if (backdrop) backdrop.addEventListener('click', hideModal);
    if (closeBtn) closeBtn.addEventListener('click', hideModal);

    // Email step
    if (emailInput) {
      emailInput.addEventListener('input', function() {
        showEmailError(false);
        emailError.textContent = 'Неверно указан email';
        updateSendButton();
      });
      emailInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && !sendCodeBtn.disabled) sendCode();
      });
    }
    if (sendCodeBtn) sendCodeBtn.addEventListener('click', sendCode);

    // Code step
    codeInputs.forEach(function(input, index) {
      if (!input) return;
      input.addEventListener('input', function(e) {
        showCodeError(false);
        let val = input.value.replace(/\D/g, '');
        if (val.length > 3) val = val.slice(0, 3);
        input.value = val;
        updateVerifyButton();
        if (val.length === 3 && index === 0 && codeInputs[1]) {
          codeInputs[1].focus();
        }
        if (getCodeValue().length === 6) {
          verifyCode();
        }
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Backspace' && input.value === '' && index > 0 && codeInputs[index - 1]) {
          codeInputs[index - 1].focus();
        }
      });
      input.addEventListener('paste', function(e) {
        e.preventDefault();
        const pasted = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '');
        if (pasted.length >= 3) {
          codeInputs[0].value = pasted.slice(0, 3);
          codeInputs[1].value = pasted.slice(3, 6);
          codeInputs[1].focus();
        } else if (index === 0) {
          codeInputs[0].value = pasted;
        }
        updateVerifyButton();
        if (getCodeValue().length === 6) verifyCode();
      });
    });

    if (verifyBtn) verifyBtn.addEventListener('click', verifyCode);
    if (backToEmailBtn) backToEmailBtn.addEventListener('click', resetEmailStep);

    // Expose global helpers
    window.goszemlyaAuth = {
      showLogin: showLogin,
      requireAuth: requireAuth,
      logout: logout,
      isAuthenticated: isAuthenticated,
      getUser: function() {
        if (currentUser) return currentUser;
        const stored = getStoredUser();
        if (stored) return stored;
        if (typeof window.tgIsAuthed === 'function' && window.tgIsAuthed()) return window.__TG_USER__;
        return null;
      },
      getToken: getToken,
    };

    // Notify other components about the initial auth state once helpers are exposed.
    const initialAuth = isAuthenticated();
    window.dispatchEvent(new CustomEvent('auth:change', { detail: { authenticated: initialAuth } }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
